import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

httpClient.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default httpClient;
